<template>
  <b-modal
    id="modal_form"
    ref="modal_form"
    :title="modal_titulo"
    :ok-title="modal_botao"
    close-title="Fechar"
    cancel-title="Cancelar"
    :ok-disabled="form.errors.any()"
    v-model="showModal"
    @ok="handleOk"
  >
    <form
      @submit.stop.prevent="handleOk"
      @keydown="form.errors.clear($event.target.name)"
    >
      <b-col class="p-0">
        <label>Transportadora</label>
        <multiselect
          v-model="transportadoraSelected"
          :options-limit="300"
          :limit="2"
          :limit-text="limitText"
          :options="optionsTransportadora"
          track-by="value"
          label="label"
          id="transportadora"
          :hide-selected="true"
          placeholder="Transportadora ( Digite 3 caracteres para pesquisar )"
          tag-placeholder="Selecionar"
          select-label="Selecionar"
          selected-label="Selecionado"
          deselect-label="Remover"
          :searchable="true"
          :loading="isLoadingTransportadora"
          @search-change="listaTransportadora"
        ></multiselect>
        <b-form-feedback
          v-text="form.errors.get('pessoa_id_for')"
          v-if="form.errors.has('pessoa_id_for')"
        ></b-form-feedback>
      </b-col>
      <b-col class="p-0">
        <label>Tipo de cálculo</label>
        <multiselect
          v-model="tpCalcSelected"
          :options="this.$parent.optionsTpCalc"
          track-by="value"
          label="label"
          :hide-selected="true"
          placeholder="Selecione"
          tag-placeholder="Selecionar"
          select-label="Selecionar"
          selected-label="Selecionado"
          deselect-label="Remover"
        ></multiselect>
        <b-form-feedback
          class="text-danger"
          v-text="form.errors.get('tp_calc')"
          v-if="form.errors.has('tp_calc')"
        ></b-form-feedback>
      </b-col>
      <b-col class="p-0">
        <label>Receita/Despesa</label>
        <b-form-group>
          <b-form-radio-group
            v-model="form.tp_receita_despesa"
            :options="this.$parent.optionsTpReceitaDespesa"
            name="tpReceitaDespesa"
            plain
            stacked
            value-field="value"
          ></b-form-radio-group>
        </b-form-group>
        <b-form-feedback
          class="text-danger"
          v-text="form.errors.get('tp_receita_despesa')"
          v-if="form.errors.has('tp_receita_despesa')"
        ></b-form-feedback>
      </b-col>

      <b-col class="p-0">
        <label>Operação</label>
        <b-form-group>
          <b-form-radio-group
            v-model="form.tp_operacao"
            :options="this.$parent.optionsTpOperacao"
            name="tpOperacao"
            plain
            stacked
            value-field="value"
          ></b-form-radio-group>
        </b-form-group>
        <b-form-feedback
          class="text-danger"
          v-text="form.errors.get('tp_operacao')"
          v-if="form.errors.has('tp_operacao')"
        ></b-form-feedback>
      </b-col>

      <b-col class="p-0">
        <label>Processo</label>
        <b-form-group>
          <b-form-radio-group
            v-model="form.tp_processo"
            :options="this.$parent.optionsTpProcesso"
            name="tpProcesso"
            plain
            stacked
            value-field="value"
          ></b-form-radio-group>
        </b-form-group>
        <b-form-feedback
          class="text-danger"
          v-text="form.errors.get('tp_processo')"
          v-if="form.errors.has('tp_processo')"
        ></b-form-feedback>
      </b-col>

      <b-col class="p-0">
        <label>Status</label>
        <b-form-group>
          <b-form-radio-group
            v-model="form.status"
            :options="this.$parent.optionsLivStatus"
            name="status"
            plain
            stacked
            value-field="value"
          ></b-form-radio-group>
        </b-form-group>
        <b-form-feedback
          v-text="form.errors.get('status')"
          v-if="form.errors.has('status')"
        ></b-form-feedback>
      </b-col>
      <b-col class="p-0">
        <label>Clientes</label>
        <multiselect
          v-model="cliente"
          :options-limit="300"
          :limit="10"
          :multiple="true"
          :limit-text="limitText"
          :options="optionsCliente"
          track-by="value"
          label="label"
          id="cliente"
          :hide-selected="true"
          placeholder="Cliente ( Digite 3 caracteres para pesquisar )"
          tag-placeholder="Selecionar"
          select-label="Selecionar"
          selected-label="Selecionado"
          deselect-label="Remover"
          :searchable="true"
          :loading="isLoadingCliente"
          @search-change="listaClientesPessoa"
        ></multiselect>
        <b-form-feedback
          v-text="form.errors.get('cliente')"
          v-if="form.errors.has('cliente')"
        ></b-form-feedback>
      </b-col>
      <b-col class="p-0">
        <label>Unidade</label>
        <multiselect
          v-model="unidadeSelected"
          :options="this.$parent.optionsUnidade"
          track-by="value"
          label="label"
          :hide-selected="true"
          placeholder="Unidade"
          tag-placeholder="Selecionar"
          select-label="Selecionar"
          selected-label="Selecionado"
          deselect-label="Remover"
        ></multiselect>
        <b-form-feedback
          v-text="form.errors.get('unidade_id')"
          v-if="form.errors.has('unidade_id')"
        ></b-form-feedback>
      </b-col>
    </form>
    <div slot="modal-footer" class="w-100">
      <div class="float-left">
        <spinner v-if="loading" message="Processando..."></spinner>
      </div>
      <div class="float-right">
        <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
        <b-btn @click="showModal = false" variant="secondary"> Fechar </b-btn>
        <b-btn
          @click="handleOk($event)"
          variant="secondary"
          :disabled="isDisabled"
        >
          Enviar
        </b-btn>
      </div>
    </div>
  </b-modal>
</template>
<script>
import AvisoErros from "../components/AvisoErros";
import accounting from "accounting";

export default {
  components: {
    AvisoErros,
  },
  props: {
    metodo: { type: Function },
    tabela: "",
    rota: "",
  },
  data() {
    return {
      cliente: [],
      dataExport: [],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      transportadoraSelected: [],
      unidadeSelected: [],
      tpCalcSelected: [],
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      isFullscreen: false,
      isLoadingTransportadora: false,
      isLoadingCliente: false,
      isLoadingUnidade: false,
      optionsCliente: [],
      optionsUnidade: [],
      optionsTransportadora: [],
      errors_array: [],
      receitaDespesaSelected: [],
      docfis: [{ docfis_id: "" }],
      form: new Form({
        pestrancal_id: "",
        pessoa_id: "",
        tp_calc: "",
        tp_receita_despesa: "",
        tp_operacao: "",
        tp_processo: "",
        status: "",
        cliente: [],
        unidade_id: "",
      }),
      helpForm: new Form({ search: "" }),
      fields: [],
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      moreParams: {},
    };
  },
  watch: {
    tpCalcSelected(obj) {
      this.form.tp_calc = obj.value;
    },
    unidadeSelected(obj) {
      this.form.unidade_id = obj.value;
    },
    transportadoraSelected(obj) {
      console.log(obj);
      this.form.pessoa_id = obj.value;
    },
  },
  methods: {
    handleOk(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStore();
      } else {
        this.onUpdate(this.form.pestrancal_id);
      }
    },
    onCreate() {
      this.transportadoraSelected = [];
      this.tpCalcSelected = [];
      this.cliente = [];
      this.unidadeSelected = [];
      this.errors_array = "";
      this.errors_array = [];
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Cadastrar parametro de calculo";
      this.modal_botao = "Enviar";
      this.modal_acao = "i";
      this.form.reset();

      this.$refs.modal_form.show();
    },
    onEdit(data) {
      this.cliente = [];
      this.unidadeSelected = [];
      this.errors_array = "";
      this.errors_array = [];
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Alterar";
      this.modal_botao = "Alterar";
      this.modal_acao = "u";
      this.form.reset();
      this.form.pestrancal_id = data.pestrancal_id;
      this.tpCalcSelected = {
        label: data.tp_calc.descr,
        value: data.tp_calc.valor,
      };
      if (data.unidade != null) {
        this.unidadeSelected = {
          label: data.unidade.descr,
          value: data.unidade.unidade_id,
        };
      }
      this.form.tp_receita_despesa = data.tp_receita_despesa.valor;
      this.form.tp_operacao = data.tp_operacao.valor;
      if (data.tp_processo != null) {
        this.form.tp_processo = data.tp_processo.valor;
      }
      this.form.status = data.status.valor;
      if (data.transportadora.pessoa_fisica !== null) {
        this.transportadoraSelected = {
          label:
            "PF -" +
            data.transportadora.pessoa_fisica.nome +
            " - " +
            data.transportadora.pessoa_fisica.cpf,
          value: data.pessoa_id,
        };
      } else if (data.transportadora.pessoa_juridica !== null) {
        this.transportadoraSelected = {
          label:
            "PJ -" +
            data.transportadora.cd +
            " - " +
            data.transportadora.pessoa_juridica.razao_social +
            " - " +
            this.onFormataCnpj(
              data.transportadora.pessoa_juridica.cnpj_base,
              data.transportadora.pessoa_juridica.cnpj_filial,
              data.transportadora.pessoa_juridica.cnpj_digito
            ).replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5") +
            " - " +
            data.transportadora.pessoa_juridica.inscricao_estadual,
          value: data.pessoa_id,
        };
      } else if (data.transportadora.pessoa_exterior !== null) {
        this.transportadoraSelected = {
          label:
            "PE -" +
            data.transportadora.pessoa_exterior.nome +
            " - " +
            data.transportadora.pessoa_exterior.cd,
          value: data.pessoa_id,
        };
      }

      if (data.pessoa_transp_calculo_pessoa.length > 0) {
        data.pessoa_transp_calculo_pessoa.forEach((obj, i) => {
          if (obj.status.valor == 1) {
            if (obj.pessoa.pessoa_fisica != null) {
              this.cliente.push({
                label:
                  obj.pessoa.pessoa_fisica.nome +
                  " - " +
                  obj.pessoa.pessoa_fisica.cpf,
                value: obj.pessoa_id,
                pessoa_id: obj.pessoa_id,
                pestrancalpes_id: obj.pestrancalpes_id,
                pestrancal_id: obj.pestrancal_id,
              });
            }
            if (obj.pessoa.pessoa_juridica != null) {
              this.cliente.push({
                label:
                  "PJ -" +
                  obj.pessoa.cd +
                  " - " +
                  obj.pessoa.pessoa_juridica.razao_social +
                  " - " +
                  this.onFormataCnpj(
                    obj.pessoa.pessoa_juridica.cnpj_base,
                    obj.pessoa.pessoa_juridica.cnpj_filial,
                    obj.pessoa.pessoa_juridica.cnpj_digito
                  ).replace(
                    /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
                    "$1.$2.$3/$4-$5"
                  ) +
                  " - " +
                  obj.pessoa.pessoa_juridica.inscricao_estadual,
                value: obj.pessoa_id,
                pessoa_id: obj.pessoa_id,
                pestrancalpes_id: obj.pestrancalpes_id,
                pestrancal_id: obj.pestrancal_id,
              });
            }
            if (obj.pessoa.pessoa_exterior != null) {
              this.cliente.push({
                label:
                  obj.pessoa.pessoa_exterior.nome +
                  " - " +
                  obj.pessoa.pessoa_exterior.cuit,
                value: obj.pessoa_id,
                pessoa_id: obj.pessoa_id,
                pestrancalpes_id: obj.pestrancalpes_id,
                pestrancal_id: obj.pestrancal_id,
              });
            }
          }
        });
      }
      this.$refs.modal_form.show();
    },
    onStore() {
      this.loading = true;
      this.isDisabled = true;
      this.form.cliente = this.cliente;
      this.form
        .put("/api/transptpcalc/store")
        .then((response) => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onUpdate(id) {
      this.loading = true;
      this.isDisabled = true;
      this.form.cliente = this.cliente;
      this.form
        .patch("/api/transptpcalc/update/" + id)
        .then((response) => {
          new ReturnApi(response, this);
          this.$parent.onFilterReset();
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    listaTransportadora(search) {
      if (search.length >= 3) {
        this.isLoadingTransportadora = true;
        this.helpForm.search = search;
        this.helpForm.status = 1;
        this.helpForm
          .post("/api/pessoa/jsonlist/transportadora")
          .then((response) => {
            this.optionsTransportadora = [];
            new ReturnApi(response, this, true, false, false);
            if (response.items.length > 0) {
              response.items.forEach((obj) => {
                console.log(obj);
                this.optionsTransportadora.push({
                  nome: obj.razao_social,
                  cpf: null,
                  cnpj: this.onFormataCnpj(
                    obj.cnpj_base,
                    obj.cnpj_filial,
                    obj.cnpj_digito
                  ).replace(
                    /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
                    "$1.$2.$3/$4-$5"
                  ),
                  ie: obj.inscricao_estadual,
                  endereco: obj.pessoa.pessoa_endereco[0].endereco,
                  municipio: obj.pessoa.pessoa_endereco[0].municipio.nome,
                  uf: obj.pessoa.pessoa_endereco[0].municipio.uf.cd,
                  label:
                    "PJ -" +
                    obj.pessoa.cd +
                    " - " +
                    obj.razao_social +
                    " - " +
                    this.onFormataCnpj(
                      obj.cnpj_base,
                      obj.cnpj_filial,
                      obj.cnpj_digito
                    ) +
                    " - " +
                    obj.inscricao_estadual,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
              });
            }
            if (response.itemsF.length > 0) {
              response.itemsF.forEach((obj) => {
                this.optionsTransportadora.push({
                  nome: obj.nome,
                  cpf: obj.cpf.replace(
                    /(\d{3})(\d{3})(\d{3})(\d{2})/,
                    "$1.$2.$3-$4"
                  ),
                  cnpj: null,
                  ie: null,
                  endereco: obj.pessoa.pessoa_endereco[0].endereco,
                  municipio: obj.pessoa.pessoa_endereco[0].municipio.nome,
                  uf: obj.pessoa.pessoa_endereco[0].municipio.uf.cd,
                  label: "PF -" + obj.nome + " - " + obj.cpf,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
              });
            }
            if (response.itemsE.length > 0) {
              response.itemsE.forEach((obj) => {
                this.optionsTransportadora.push({
                  nome: obj.nome,
                  cpf: null,
                  cnpj: obj.cuit,
                  ie: null,
                  endereco: obj.pessoa.pessoa_endereco[0].endereco,
                  municipio: obj.pessoa.pessoa_endereco[0].municipio.nome,
                  uf: obj.pessoa.pessoa_endereco[0].municipio.uf.cd,
                  label: "PE -" + obj.nome + " - " + obj.cd,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
              });
            }
            this.isLoadingTransportadora = false;
          })
          .catch((errors) => {
            new ReturnApi(errors, this);
          });
      }
    },
    listaClientesPessoa(search) {
      if (search.length >= 3) {
        this.isLoadingCliente = true;
        this.helpForm.search = search;
        this.helpForm.status = 1;
        this.helpForm
          .post("/api/pessoa/jsonlist/cliente")
          .then((response) => {
            this.optionsCliente = [];
            new ReturnApi(response, this, true, false, false);
            if (response.items.length > 0) {
              response.items.forEach((obj) => {
                this.optionsCliente.push({
                  nome: obj.razao_social,
                  cpf: null,
                  cnpj: this.onFormataCnpj(
                    obj.cnpj_base,
                    obj.cnpj_filial,
                    obj.cnpj_digito
                  ).replace(
                    /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
                    "$1.$2.$3/$4-$5"
                  ),
                  ie: obj.inscricao_estadual,
                  endereco: obj.pessoa.pessoa_endereco[0].endereco,
                  municipio: obj.pessoa.pessoa_endereco[0].municipio.nome,
                  uf: obj.pessoa.pessoa_endereco[0].municipio.uf.cd,
                  label:
                    "PJ -" +
                    obj.pessoa.cd +
                    " - " +
                    obj.razao_social +
                    " - " +
                    this.onFormataCnpj(
                      obj.cnpj_base,
                      obj.cnpj_filial,
                      obj.cnpj_digito
                    ) +
                    " - " +
                    obj.inscricao_estadual,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
              });
            }
            if (response.itemsF.length > 0) {
              response.itemsF.forEach((obj) => {
                this.optionsCliente.push({
                  nome: obj.nome,
                  cpf: obj.cpf.replace(
                    /(\d{3})(\d{3})(\d{3})(\d{2})/,
                    "$1.$2.$3-$4"
                  ),
                  cnpj: null,
                  ie: null,
                  endereco: obj.pessoa.pessoa_endereco[0].endereco,
                  municipio: obj.pessoa.pessoa_endereco[0].municipio.nome,
                  uf: obj.pessoa.pessoa_endereco[0].municipio.uf.cd,
                  label: "PF -" + obj.nome + " - " + obj.cpf,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
              });
            }
            if (response.itemsE.length > 0) {
              response.itemsE.forEach((obj) => {
                this.optionsCliente.push({
                  nome: obj.nome,
                  cpf: null,
                  cnpj: obj.cuit,
                  ie: null,
                  endereco: obj.pessoa.pessoa_endereco[0].endereco,
                  municipio: obj.pessoa.pessoa_endereco[0].municipio.nome,
                  uf: obj.pessoa.pessoa_endereco[0].municipio.uf.cd,
                  label: "PE -" + obj.nome + " - " + obj.cd,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
              });
            }
            this.isLoadingCliente = false;
          })
          .catch((errors) => {
            new ReturnApi(errors, this);
          });
      }
    },
    onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      var cnpj_formatado;
      var pad = "00000000";
      var cnpj_base =
        pad.substring(0, pad.length - cnpj_base.toString().length) + cnpj_base;
      var pad = "0000";
      var cnpj_filial =
        pad.substring(0, pad.length - cnpj_filial.toString().length) +
        cnpj_filial;
      var pad = "00";
      var cnpj_digito =
        pad.substring(0, pad.length - cnpj_digito.toString().length) +
        cnpj_digito;
      return cnpj_base + "" + cnpj_filial + "" + cnpj_digito;
    },
    onActivateDesactivate(helpForm) {
      helpForm
        .patch("/api/transptpcalc/status")
        .then((response) => {
          new ReturnApi(response, this);

          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onActivateDesactivateCliente(helpForm) {
      helpForm
        .patch("/api/transptpcalc/statuscliente")
        .then((response) => {
          new ReturnApi(response, this);

          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    limitText(count) {
      return " e ${count} outros clientes";
    },

    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    formatNumber(value) {
      return accounting.formatNumber(value, 2, ".", ",");
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
  },
};
</script>
